import { StackNavigationOptions } from "@react-navigation/stack";
import React from "react";
import ScreenNameType from "@navigation/nav-screens";
import PasswordLoginScreen from "../modules/login/password-login/password-login";
import NotFound from "app/modules/not-found/not-found";

interface IRootStack {
  name: string;
  route: string;
  component: React.ComponentType<any>;
  options?: StackNavigationOptions;
  auth: boolean;
}

const CommonStack: Array<IRootStack> = [
  {
    name: ScreenNameType.NOT_FOUND,
    route: ScreenNameType.NOT_FOUND.toLowerCase(),
    component: NotFound,
    auth: false,
    options: { headerShown: false },
  },
];

const AuthStack: Array<IRootStack> = [
  {
    name: ScreenNameType.PASSWORD_LOGIN,
    route: ScreenNameType.PASSWORD_LOGIN.toLowerCase(),
    component: PasswordLoginScreen,
    auth: false,
    options: { headerShown: false },
  },
];

export { AuthStack, CommonStack };
